function escapeCell(val) {
  if (val === null || val === undefined) return "";
  const s = String(val);
  if (/[",\n\r]/.test(s)) {
    return '"' + s.replace(/"/g, '""') + '"';
  }
  return s;
}

export function exportToCsv(filename, headers, rows) {
  const headerLine = headers.map(escapeCell).join(",");
  const dataLines = rows.map((row) => headers.map((h) => escapeCell(row[h])).join(","));
  const csvText = [headerLine, ...dataLines].join("\n");

  const blob = new Blob([csvText], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
